var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4987 0.568359L28.4154 5.08919V15.5C28.4154 20.8307 25.1436 24.5572 22.0914 26.8706C20.2502 28.2545 18.2297 29.3821 16.0851 30.2224L15.9727 30.2651L15.9404 30.2767L15.9314 30.2793L15.9275 30.2806C15.9262 30.2806 15.9249 30.2806 15.4987 29.0625L15.0712 30.2819L15.066 30.2793L15.0569 30.2767L15.0247 30.2638L14.9123 30.2224C14.3031 29.9869 13.7041 29.7257 13.1169 29.4397C11.6345 28.7196 10.2245 27.8593 8.90603 26.8706C5.85511 24.5572 2.58203 20.8307 2.58203 15.5V5.08919L15.4987 0.568359ZM15.4987 29.0625L15.0712 30.2819L15.4987 30.4317L15.9262 30.2819L15.4987 29.0625ZM15.4987 27.6779L15.5103 27.6727C17.2976 26.934 18.9844 25.9727 20.531 24.8117C23.2926 22.7204 25.832 19.6631 25.832 15.5V6.92336L15.4987 3.30669L5.16536 6.92336V15.5C5.16536 19.6631 7.70478 22.7179 10.4664 24.8129C12.0164 25.9762 13.7072 26.9388 15.4987 27.6779ZM23.3417 10.7764L14.2083 19.9098L8.72778 14.4305L10.5555 12.6028L14.207 16.2569L21.514 8.94998L23.3417 10.7764Z",
    fill: "url(#paint0_linear_1714_4853)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4853",
    x1: 2.58203,
    y1: -3.16456,
    x2: 34.5034,
    y2: 27.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr6);
export default __webpack_public_path__ + "static/media/Hr6.541fd4a7f5f06c146e826cf379bc8f91.svg";
export { ForwardRef as ReactComponent };